const PENDING_ACTIONS_KEY = '@CANNECT_PENDING_ACTIONS'

export interface PendingAction {
  type: 'ADD_TO_CART' | 'TOGGLE_FAVORITE'
  payload: {
    productId?: number
    classId?: number
    brandId?: number
    quantity?: number
    type?: string
  }
}

export const usePendingActions = () => {
  const setPendingAction = (action: PendingAction) => {
    localStorage.setItem(PENDING_ACTIONS_KEY, JSON.stringify(action))
  }

  const getPendingAction = (): PendingAction | null => {
    const stored = localStorage.getItem(PENDING_ACTIONS_KEY)
    return stored ? JSON.parse(stored) : null
  }

  const removePendingAction = () => {
    localStorage.removeItem(PENDING_ACTIONS_KEY)
  }

  return {
    setPendingAction,
    getPendingAction,
    removePendingAction
  }
}
